const Add = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8332 10.8334H10.8332V15.8334H9.16656V10.8334H4.16656V9.16675H9.16656V4.16675H10.8332V9.16675H15.8332V10.8334Z"
        fill={color}
      />
    </svg>
  );
};
export default Add;
